/**
 * @generated SignedSource<<5f19def8ba2017b9bd69def227185420>>
 * @relayHash de027579be0b6c6a78a696de7cba6449
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 41233f6f17efda26cb3c35b13d9c57009846d6bf2cc786fc49a7f28c9165f07e

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildEventsScreenQuery$variables = {
  id: string;
};
export type GuildEventsScreenQuery$data = {
  readonly nodeBySlugId: {
    readonly __typename: "Guild";
    readonly name: string;
    readonly pastEventsCount: {
      readonly totalCount: number;
    };
    readonly upcomingEventsCount: {
      readonly totalCount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"GuildMetadata_guild">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type GuildEventsScreenQuery = {
  response: GuildEventsScreenQuery$data;
  variables: GuildEventsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v5 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "START_AT_DESC",
    "ID_ASC"
  ]
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v7 = {
  "alias": "upcomingEventsCount",
  "args": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "timeSelection",
      "value": "UPCOMING"
    }
  ],
  "concreteType": "EventsConnection",
  "kind": "LinkedField",
  "name": "eventsByTimeSelection",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
},
v8 = {
  "alias": "pastEventsCount",
  "args": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "timeSelection",
      "value": "PAST"
    }
  ],
  "concreteType": "EventsConnection",
  "kind": "LinkedField",
  "name": "eventsByTimeSelection",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"PAST\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildEventsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMetadata_guild"
              },
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildEventsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slugId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "type": "Guild",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "41233f6f17efda26cb3c35b13d9c57009846d6bf2cc786fc49a7f28c9165f07e",
    "metadata": {},
    "name": "GuildEventsScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ee5dd36af9afef22e573c87b251063d4";

export default node;
